define(
  'DeliveryMethod.EntryPoint',
  [
    'underscore'
  ],
  function (
    _
  ) {
    'use strict';

    var FREE_TEXT = 'Free!';
    var SHIPMETHOD_VIEWS = [
      'OrderWizard.Module.Shipmethod',
      'OrderWizard.Module.ShowShipments'
    ];

    function clearFreeRate(shippingMethod) {
      if (shippingMethod && shippingMethod.rate_formatted === FREE_TEXT) {
        // eslint-disable-next-line camelcase
        shippingMethod.rate_formatted = '';
      }
      return shippingMethod;
    }

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');

        if (!layout) {
          return;
        }

        _.each(SHIPMETHOD_VIEWS, function (viewName) {
          layout.addToViewContextDefinition(viewName, 'shippingMethods', 'array', function (context) {
            return _.map(context.shippingMethods || [], clearFreeRate);
          });
        });
      }
    };
  });
